import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { postData, useResource } from '../backend';
import { useModal } from '../contexts';
import { SubscriptionTier } from '../interfaces';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';
import posthog from 'posthog-js';

function PayWallModalTeams() {
  const tier: SubscriptionTier | null = useResource("/billing/tiers/teams/");
  const { t } = useTranslation();


  const [checkoutUrl, setCheckoutUrl] = useState<string>();
  const { closeModal } = useModal();

  useEffect(() => {
    //@ts-ignore
    const dataLayer = window.dataLayer;
    dataLayer.push({ 'event': 'view_paywall', 'paywall_type': 'teams' });

    posthog.capture("paywall_view", {
      "upgrade_tier": "teams"
    });
  }, [])

  useEffect(() => {
    if (!tier)
      return

    //@ts-ignore
    const dataLayer = window.dataLayer;
    dataLayer.push({ 'event': 'click_upgrade', 'upgrade_tier': tier.slug });

    postData(`/billing/tiers/${tier.slug}/checkout/`, { stripePriceId: tier!.stripeMonthlyPriceId })
      .then(data => setCheckoutUrl(data.url))
      .catch(console.error);
  }, [tier]);

  return (
    <Modal
      title={t("Upgrade to Teams to share workflows")}
      subtitle={
        <p className="font-semibold text-sm text-gray-500">
          {t("Your current plan does not provide access to this feature.")} <br />
          {t("Upgrade to the Teams plan to share workflows with other people.")}
        </p>
      }
      size='sm'
    >
      {tier && <>
        <div className="flex flex-col gap-1 w-full">
          <div className="font-gilroy font-semibold">
            {t("Teams")}
          </div>
          <div className="flex items-center">
            <div className="flex items-start flex-wrap flex-shrink-0">
              <div className="text-sm">$</div>
              {!!tier
                ? <div className="text-3xl font-semibold">{String(Math.floor(tier.stripeMonthlyPrice / 100))}<span className="text-xs ml-1 mt-auto mb-1">{t("/month (USD)")}</span></div>
                : <div className="text-3xl font-semibold loading-ellipse" />
              }
            </div>
          </div>
        </div>
        <button className='btn btn-blue w-full' onClick={() => checkoutUrl && window.open(checkoutUrl, "_blank")}>
          {t("Upgrade")}
        </button>
        <div className='flex flex-col text-sm font-semibold gap-2 mt-2'>
          <div className='text-gray-400 font-bold'>{t("What's included")}</div>
          <div><span className='text-green'>&#9679;</span>&nbsp;&nbsp;{tier.featureDocumentLimit} {t("documents per month")}</div>
          <div><span className='text-green'>&#9679;</span>&nbsp;&nbsp;{t("Create a team with up to 5 members")}</div>
          <div><span className='text-green'>&#9679;</span>&nbsp;&nbsp;{t("Shared workflows")}</div>
          <div><span className='text-green'>&#9679;</span>&nbsp;&nbsp;{t("Have team members approve workflows")}</div>
        </div>
        <Link to="/settings/billing" className='text-center w-full text-sm text-gray-400 underline' onClick={() => closeModal()}>
          {t("Compare all plans")}
        </Link>
      </>}
    </Modal>
  );
}

export default PayWallModalTeams;
